
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
clear () {

},
async next () {
this.currentPage--
await this.doQuery()
},
async perv () {
this.currentPage++
await this.doQuery()
},
async OnSelectYear () {
await this.doQuery()
},
async getYears () {
const queryPromise = await this.$http.get('/API/MainGoods/Years')
return queryPromise.data
},
async doQuery () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
this.queryParams['pageNumber'] = this.currentPage
const queryPromise = await this.$http.get('/API/MainGoods/Search'
, {params: this.queryParams})
this.queryResult = queryPromise.data
this.$vux.loading.hide()
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
showDesc (index) {
let current = this.queryResult.Data[index]
this.$router.push({name: 'MainGoodsSearchDetail', params: current})
}
},
data () {
return {
yearList: ['', '2017', '2016', '2015', '2016'],
year: '2017',
queryResult: {Data: [], TotalPage: 0},
currentPage: 1,
queryParams: this.$route.params
}
},
async created () {
this.yearList = (await this.getYears()).sort().reverse()
if (this.yearList.length > 0) {
this.year = this.queryParams.year
}
await this.doQuery()
}
}



// WEBPACK FOOTER //
// ./src/components/MainGoodsSearchResult.vue